<template>
    <div class="translations-edit">
        <div v-for="(text, language) in translationData" :key="language">
            <ui5-label class="language">
                {{ getEmoji(language) }} {{ language }}
            </ui5-label>
            <ui5-input :value="text" @input="updateValue($event, language)" />
            <div
                class="error"
                :key="language + '-error'"
                v-if="getErrorFromValidator($v.translationData[language])">
                {{ getErrorFromValidator($v.translationData[language]) }}
            </div>
        </div>
    </div>
</template>

<script>
import ErrorHelper from '../helpers/ErrorHelper';
import { maxLength } from 'vuelidate/lib/validators';
import LocalizationHelper from '../helpers/LocalizationHelper';

export default {
    props: {
        translationData: {
            type: Object,
            required: true,
        },
        languageValueUpdated: {
            type: Function,
            required: false,
            default: () => {},
        },
        extraValidations: {
            type: Object,
            required: false,
            default: () => ({}),
        },
        getErrorFromValidator: {
            type: Function,
            required: false,
            default: ErrorHelper.getErrorFromValidator,
        },
    },
    methods: {
        getEmoji: LocalizationHelper.languageCodeToEmoji,
        updateValue($event, language) {
            this.translationData[language] = $event.target.value;
            this.languageValueUpdated(language, $event.target.value);
        },
    },
    computed: {},
    validations() {
        const labelValidations = {};
        Object.keys(this.translationData).forEach((x) => {
            labelValidations[x] = {
                maxLength: maxLength(65535),
                ...this.extraValidations,
            };
        });

        return {
            translationData: labelValidations,
        };
    },
};
</script>
